export default "__VITE_ASSET__BnoZ5K12__"